import React from "react";

const ProcessingBar2 = () => {
  return (
    <span
      style={{
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "#ca7100",
        boxShadow: "32px 0 #ca7100, -32px 0 #ca7100",
        animation: "flash 0.5s ease-out infinite alternate",
      }}
      className="block"
    />
  );
};

<style>
  {`
    @keyframes flash {
      0% {
        background-color: #ca7100;
        box-shadow: 32px 0 #ca7100, -32px 0 #ca7100;
      }
      50% {
        background-color: #ca7100;
        box-shadow: 32px 0 #ca7100, -32px 0 #ca7100;
      }
      100% {
        background-color: #ca7100;
        box-shadow: 32px 0 #ca7100, -32px 0 #ca7100;
      }
    }
  `}
</style>;

export default ProcessingBar2;
